import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e62cfdd8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e62cfdd8&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=e62cfdd8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62cfdd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e62cfdd8')) {
      api.createRecord('e62cfdd8', component.options)
    } else {
      api.reload('e62cfdd8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e62cfdd8&scoped=true", function () {
      api.rerender('e62cfdd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Modal/index.vue"
export default component.exports